module.exports = __webpack_public_path__ + "img/overview-dashboard.28b63150.svg";